import { render, staticRenderFns } from "./taxCreditRating.vue?vue&type=template&id=827fc030&scoped=true"
import script from "./taxCreditRating.vue?vue&type=script&lang=js"
export * from "./taxCreditRating.vue?vue&type=script&lang=js"
import style0 from "./taxCreditRating.vue?vue&type=style&index=0&id=827fc030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827fc030",
  null
  
)

export default component.exports